import { render, staticRenderFns } from "./libro-despliegue.vue?vue&type=template&id=ca415b0a"
import script from "./libro-despliegue.vue?vue&type=script&lang=js"
export * from "./libro-despliegue.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports